import React, { useCallback, useEffect, useState, useRef } from "react";
import { format } from "date-fns";
// Pagination component
import Grid from "@mui/material/Grid";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  ListItem,
  Paper,
  Popper,
  Tab,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import AutoCompleteComponent from "../../components/autoCompleteComponent/Autocomplete";
import DatePicker from "../../components/dateRangePickerComponent/DateRangePicker";
import MuiButton from "../../components/muiButton/MuiButton";
import PostPlusButton from "../../components/postPlusButton/PostPlusButton";
import LoadingIndicator from "../../components/loading-indicator/LoadingIndicator";
import NoDataFound from "../../components/nodatafound/NoDataFound";
import { theme } from "../App";
import InstagramIcon from "@mui/icons-material/Instagram";
import InfluencersCampaignsAction from "../../stores/influencersCampaigns/InfluencersCampaignsAction";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import PaginationUI from "../../components/pagination/Pagination";
import InfluencersActivityAction from "../../stores/influencersActivity/InfluencersActivityAction";
import AddAllActivity from "./AddAllActivity";
import InfluencerUserAction from "../../stores/influencerUser/InfluencerUserAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import GoogleIcon from "@mui/icons-material/Google";
import EmailIcon from "@mui/icons-material/Email";
import StarIcon from "@mui/icons-material/Star";
import ActivityTypeAction from "../../stores/influencerActivityType/ActivityTypeAction";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ClearIcon from "@mui/icons-material/Clear";
import { returnLogo } from "../../components/ticketPartials";
import StatusAction from "../../stores/status/StatusAction";
import TagAction from "../../stores/tag/TagAction";
import CustomTicketFieldsAction from "../../stores/customticketfields/CustomTicketFieldsAction";
import LocationAction from "../../stores/location/LocationAction";
import MuiSnackbarAlert from "../../components/muiSnackBarAlert/MuiSnackbarAlert";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import MuiTextField from "../../components/muiTextField/MuiTextField";

// mapstateto props function
const mapStateToProps = (state, ownProps) => ({
  isRequesting: selectRequesting(state, [
    InfluencersActivityAction.REQUEST_INFLUENCERS_ACTIVITY,
    InfluencersActivityAction.REQUEST_INFLUENCERS_ACTIVITY_FILTER,
    InfluencersCampaignsAction.REQUEST_INFLUENCERS_CAMPAIGNS_FILTER,
    InfluencerUserAction.REQUEST_INFLUENCER_USER,
    ActivityTypeAction.REQUEST_ACTIVITY_TYPE_FILTER,
    LocationAction.REQUEST_LOCATION,
  ]),
  influencersActivity: state.influencersActivity.influencersActivity || [],
  pagination: state.influencersActivity.influencersActivity || {},
  influencersActivityFilter:
    state.influencersActivityFilter.influencersActivityFilter || [],
  influencersCampaignFilter:
    state.influencersCampaignFilter.influencersCampaignFilter.hits || [],
  influencerUser: state.influencerUser.influencerUser || [],
  activityTypeFilter: state.activityTypeFilter.activityTypeFilter || [],
  statusFilter: state.statusFilter.statusFilter || [],
  tagfilter: state.tagfilter.tagfilter || [],
  customticketfields: state.customticketfields.customticketfields || {},
  influencer_location: state.influencer_location.influencer_location || {},
});

function InfluencersAllActivity(props) {
  const localFilters = JSON.parse(localStorage.getItem("myActivityClient"));

  // useState Functions
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [value, setValue] = React.useState("1");
  const [page_limit] = useState(15);
  const [sentimentalValue, setSentimentalValue] = useState("");
  const [filterLoader, setFilterLoader] = useState(false);
  const [clearLoader, setClearLoader] = useState(false);
  const [FilterClicked, setFilterClicked] = useState(false);
  const [tag_value, setTag_value] = useState([]);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [editRowsModel, setEditRowsModel] = useState({});
  const [location_value, setLocation_value] = useState("");
  const location = useLocation();
  const boxRef = useRef(null);

  const [showDropDowns, setShowDropDowns] = useState(() => {
    if (location && location.state && location.state.campaign_name) {
      return [
        "ActivityName",
        "ActivityType",
        "Platform",
        "Date",
        "Location",
        "Tags",
      ];
    } else {
      return [
        "ActivityName",
        "Campaign",
        "ActivityType",
        "Platform",
        "Date",
        "Location",
        "Tags",
      ];
    }
  });

  const [selected, setSelected] = useState(() => {
    if (location && location.state && location.state.campaign_name) {
      return ["ActivityName", "ActivityType", "Platform", "Date"];
    } else {
      return ["ActivityName", "Campaign", "ActivityType", "Platform", "Date"];
    }
  });

  // Fetching from LocalStorage
  const [campaignNameValue, setCampaignNameValue] = useState(() => {
    return localFilters ? localFilters.campaignNameValue : "";
  });
  const [activity_type_value, setActivity_type_value] = useState(() => {
    return localFilters ? localFilters.activityTypeValue : "";
  });
  const [platform_value, setPlatform_value] = useState(() => {
    return localFilters ? localFilters.platformValue : "";
  });
  const [activityNameValue, setActivityNameValue] = useState(() => {
    return localFilters ? localFilters.activityNameValue : "";
  });
  const [date, setDate] = useState(() => {
    return localFilters ? localFilters.dateValue : [null, null];
  });
  const [pageNumber, setPageNumber] = useState(() => {
    return localFilters ? localFilters.pageNumber : 1;
  });

  const [popperAnchor, setPopperAnchor] = React.useState(null);

  const handleClick = (event) => {
    setPopperAnchor(popperAnchor ? null : event.currentTarget);
  };

  const openPopper = Boolean(popperAnchor);

  const handleChangeDropDowns = (event) => {
    const value = event.target.value;

    if (selected.indexOf(value) !== -1) {
      // if value already present
      const newSelected = selected.filter((s) => s !== value);
      setSelected(newSelected);
    } else {
      // if value not present
      setSelected([...selected, value]);
    }
  };

  const openCloseModal = useCallback((open) => {
    setOpen(open);
  }, []);

  const editMode = useCallback((edit) => {
    setEdit(false);
  }, []);

  let date_format = [];

  if (date[0]) {
    date_format.push(date[0].$d);
  }

  if (date_format[0]) {
    format(date_format[0], "yyyy-mm-dd");
  }

  if (date[1]) {
    date_format.push(date[1].$d);
  }

  if (date_format[1]) {
    format(date_format[1], "yyyy-mm-dd");
  }

  // importing useStyes hook
  const { isRequesting } = props;

  //tab handle change
  const TabhandleChange = (event, newValue) => {
    setValue(newValue);
  };

  // ************************************************* Dispatch functions

  function fetchInfluencersActivity() {
    let filter = [];
    if (location && location.state && location.state.campaign_name) {
      filter.push(
        `["campaign.campaign_name.keyword","must","","term","${location.state.campaign_name}"]`
      );
    }
    let params = {};

    Object.assign(
      params,
      { page_limit: `${page_limit}` },
      location &&
        location.state &&
        (location.state?.from === "/InfluencersCampaigns" ||
          location.state?.from === "/influencerDashboard") && {
          filters: `[${filter}]`,
        },
      { order_by: '[["created_on", "desc"]]' }
    );
    props.dispatch(
      InfluencersActivityAction.requestInfluencersActivity(params)
    );
  }

  const fetchInfluencerLocation = () => {
    props.dispatch(LocationAction.requestLocation({ page_limit: "none" }));
  };

  function fetchActivityTypeFilter(params) {
    let param = {
      page_limit: "none",
    };
    props.dispatch(ActivityTypeAction.requestActivityTypeFilter(param));
  }

  function fetchInfluencersActivityFilter() {
    let params = {
      page_limit: "none",
    };
    props.dispatch(
      InfluencersActivityAction.requestInfluencersActivityFilter(params)
    );
  }

  function fetchInfluencersCampaignFilter() {
    let params = {
      page_limit: "none",
    };
    props.dispatch(InfluencersCampaignsAction.requestInfluencersFilter(params));
  }

  function fetchInfluenceUser() {
    let params = {
      page_limit: "none",
      order_by: '[["created_on", "desc"]]',
    };
    props.dispatch(InfluencerUserAction.requestInfluencerUser(params));
  }

  function fetchStatusFilter() {
    const param = {
      page_limit: "none",
      order_by: `[["order_number","asc"]]`,
    };
    props.dispatch(StatusAction.requestStatusFilter(param));
  }

  function fetchTagFilter() {
    const param = {
      page_limit: "none",
      order_by: `[["order_number","asc"]]`,
    };
    props.dispatch(TagAction.requestTagFilter(param));
  }

  // Fetch Custom Fields
  function fetchCustomTicketFields() {
    let params = {
      page_limit: "none",
      filters: `[["project.project_name.keyword","must","","term","${
        localStorage.getItem("user_last_working_project_name")
          ? localStorage.getItem("user_last_working_project_name")
          : ""
      }"]]`,
    };
    props.dispatch(CustomTicketFieldsAction.requestCustomTicketFields(params));
  }

  useEffect(() => {
    if (!isRequesting) {
      setFilterLoader(false);
      setClearLoader(false);
    }
  }, [isRequesting]);

  const [token, setToken] = useState(null);

  useEffect(() => {
    if (!localFilters) {
      fetchInfluencersActivity();
      fetchInfluencersActivityFilter();
      fetchInfluencersCampaignFilter();
      fetchInfluenceUser();
      fetchActivityTypeFilter();
      fetchInfluencerLocation();
    } else applyFilter();
    //   // fetchStatusFilter();
    //   // fetchTagFilter();
    //   // fetchCustomTicketFields();
  }, []);

  // applyFilter Function
  const applyFilter = () => {
    let params = {};
    const filter = [];

    if (campaignNameValue) {
      {
        filter.push(
          `["campaign.campaign_name.keyword","must","","wildcard","*${campaignNameValue}*"]`
        );
      }
    }

    if (activity_type_value) {
      {
        filter.push(
          `["activity_type.keyword","must","","term","${activity_type_value.activity_type_id}"]`
        );
      }
    }

    const returnArrayOfTagIds = (arrayOfObjects) => {
      let arrayOfIds = [];
      arrayOfObjects.length > 0 &&
        arrayOfObjects.map((item) => {
          arrayOfIds.push(item.tag_id);
        });
      return arrayOfIds;
    };

    if (tag_value && tag_value.length !== 0) {
      {
        filter.push(
          `["activity_tag.keyword","must","","terms",${JSON.stringify(
            returnArrayOfTagIds(tag_value)
          )}]`
        );
      }
    }

    if (platform_value) {
      {
        filter.push(
          `["activity_platform.platform_name.keyword","must","","term","${platform_value}"]`
        );
      }
    }

    if (location_value) {
      {
        filter.push(
          `["activity_location.keyword","must","","term","${location_value}"]`
        );
      }
    }

    if (activityNameValue) {
      {
        filter.push(
          `["activity_name.keyword","must","","wildcard","*${activityNameValue}*"]`
        );
      }
    }

    if (date[0] !== null && date[1] !== null) {
      filter.push(CustomDateFilter());
    }

    if (
      campaignNameValue ||
      platform_value ||
      activity_type_value ||
      location_value ||
      activityNameValue ||
      (tag_value && tag_value.length !== 0) ||
      (date[0] !== null && date[1] !== null)
    ) {
      params = {
        filters: `[${filter}]`,
        page_limit: `${page_limit}`,
        order_by: '[["created_on", "desc"]]',
      };
      setFilterLoader(true);
      setFilterClicked(true);
      props.dispatch(
        InfluencersActivityAction.requestInfluencersActivity(params)
      );

      localStorage.setItem(
        "myActivityClient",
        JSON.stringify({
          activityNameValue: activityNameValue,
          campaignNameValue: campaignNameValue,
          activityTypeValue: activity_type_value,
          platformValue: platform_value,
          dateValue: date,
          pageNumber: pageNumber,
        })
      );
    } else {
      setAlertPopUp(true);
    }
  };

  function CustomDateFilter() {
    if (date[1].$d || date[0].$d)
      return `["activity_duration.from_date","must","lte","range","${format(
        date[1].$d,
        "yyyy-MM-dd"
      )}"],["activity_duration.from_date","must","gte","range","${format(
        date[0].$d,
        "yyyy-MM-dd"
      )}"]`;
    else {
      return `["activity_duration.from_date","must","lte","range","${format(
        new Date(date[1]),
        "yyyy-MM-dd"
      )}"],["activity_duration.from_date","must","gte","range","${format(
        new Date(date[0]),
        "yyyy-MM-dd"
      )}"]`;
    }
  }

  //  autocompleteHandleChange
  const autocompleteHandleChange = (event, value) => {
    if (value != null) {
      setSentimentalValue(value);
    } else {
      setSentimentalValue("");
    }
  };

  //  campaignNameHandleChange
  const campaignNameHandleChange = (event) => {
    setCampaignNameValue(event.target.value);
  };

  //  activityTypeHandleChange
  const activityTypeHandleChange = (event, value) => {
    setActivity_type_value(value);
  };

  //  platform_HandleChange
  const platform_HandleChange = (event, value) => {
    setPlatform_value(value);
  };

  //  location_HandleChange
  const location_HandleChange = (event, value) => {
    if (value != null) {
      setLocation_value(value);
    } else {
      setLocation_value("");
    }
  };

  //  activity_name_HandleChange
  const activityNameHandleChange = (event, value) => {
    setActivityNameValue(event.target.value);
  };

  const dateHandlechange = (value) => {
    if (value === null) {
      setDate([null, null]);
    } else {
      setDate(value);
    }
  };

  const dateValueHandleChange = (e, v) => {
    setDate(e);
  };

  const uniqueList = ["Positive", "Negative", "Neutral"];

  // Clear method
  const ClearState = () => {
    setFilterClicked(false);

    if (
      campaignNameValue ||
      platform_value ||
      activity_type_value ||
      location_value ||
      activityNameValue ||
      (tag_value && tag_value.length !== 0) ||
      (date[0] !== null && date[1] !== null)
    ) {
      setCampaignNameValue("");
      setActivity_type_value("");
      setPlatform_value("");
      setLocation_value("");
      setActivityNameValue("");
      setDate([null, null]);
      setClearLoader(true);
      setTag_value([]);
      localStorage.removeItem("myActivityClient");

      if (navigator.onLine === true) {
        // const params = {
        //   page_limit: `${page_limit}`,
        //   order_by: '[["created_on", "desc"]]',
        // };
        fetchInfluencersActivity();
        fetchInfluencersActivityFilter();
        fetchInfluencersCampaignFilter();
        fetchInfluenceUser();
        fetchActivityTypeFilter();
      }
    } else {
      setAlertPopUp(true);
    }
  };

  // pagination
  const handleChangePagination = (event, value) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    let params = {};
    const filter = [];

    if (campaignNameValue) {
      {
        filter.push(
          `["campaign.campaign_name.keyword","must","","wildcard","*${campaignNameValue}*"]`
        );
      }
    }

    if (activity_type_value) {
      {
        filter.push(
          `["activity_type.keyword","must","","term","${activity_type_value.activity_type_id}"]`
        );
      }
    }

    if (platform_value) {
      {
        filter.push(
          `["activity_platform.platform_name.keyword","must","","term","${platform_value}"]`
        );
      }
    }

    if (location_value) {
      {
        filter.push(
          `["activity_location.keyword","must","","term","${location_value}"]`
        );
      }
    }

    const returnArrayOfTagIds = (arrayOfObjects) => {
      let arrayOfIds = [];
      arrayOfObjects.length > 0 &&
        arrayOfObjects.map((item) => {
          arrayOfIds.push(item.tag_id);
        });
      return arrayOfIds;
    };

    if (tag_value && tag_value.length !== 0) {
      {
        filter.push(
          `["activity_tag.keyword","must","","terms",${JSON.stringify(
            returnArrayOfTagIds(tag_value)
          )}]`
        );
      }
    }

    // created_time filter
    if (date[0] !== null && date[1] !== null) {
      filter.push(CustomDateFilter());
    }

    if (FilterClicked) {
      if (
        (campaignNameValue ||
          platform_value ||
          activity_type_value ||
          location_value ||
          (tag_value && tag_value.length !== 0),
        date[0] !== null && date[1] !== null)
      ) {
        params = {
          filters: `[${filter}]`,
          page_number: `${value}` - 1,
          page_limit: `${page_limit}`,
          order_by: '[["created_on", "desc"]]',
        };
      }
    } else {
      params = {
        page_number: `${value}` - 1,
        page_limit: `${page_limit}`,
        order_by: '[["created_on", "desc"]]',
      };
    }
    props.dispatch(
      InfluencersActivityAction.requestInfluencersActivity(params)
    );
    setPageNumber(value);
    let filters = localFilters;
    if (filters) {
      filters.pageNumber = value;
      localStorage.setItem("myActivityClient", JSON.stringify(filters));
    }
  };

  //  tag_HandleChange
  const tag_HandleChange = (event, value) => {
    if (value != null) {
      setTag_value(value);
    } else {
      setTag_value([]);
    }
  };

  const navigate = useNavigate();

  let campaignList = [];

  if (props.influencersCampaignFilter.hits) {
    props.influencersCampaignFilter.hits.map((item) => {
      return campaignList.push({
        campaign_id: item._id,
        campaign_name: item._source.campaign_name,
      });
    });
  }

  let campaign_name_uniqueList = [];

  if (campaignList.length > 0) {
    campaignList.map((item) => {
      campaign_name_uniqueList.push(item.campaign_name);
    });
  }
  campaign_name_uniqueList = [...new Set(campaign_name_uniqueList)];

  campaign_name_uniqueList.sort((a, b) => a.localeCompare(b));
  campaign_name_uniqueList = [...new Set(campaign_name_uniqueList)];

  let locations_uniqueList = [];

  if (props.influencersActivityFilter.hits) {
    props.influencersActivityFilter.hits &&
      props.influencersActivityFilter.hits.hits.length > 0 &&
      props.influencersActivityFilter.hits.hits.map((item) => {
        locations_uniqueList.push(
          item._source.activity_location ? item._source.activity_location : ""
        );
      });
  }

  let activity_name_uniqueList = [];

  if (props.influencersActivityFilter.hits) {
    props.influencersActivityFilter.hits &&
      props.influencersActivityFilter.hits.hits.length > 0 &&
      props.influencersActivityFilter.hits.hits.map((item) => {
        activity_name_uniqueList.push(
          item._source.activity_name ? item._source.activity_name : ""
        );
      });
  }

  activity_name_uniqueList = [...new Set(activity_name_uniqueList)];

  activity_name_uniqueList.sort((a, b) => a.localeCompare(b));
  activity_name_uniqueList = [...new Set(activity_name_uniqueList)];

  const returndate = (given) => {
    let dateConversion = new Date(given);
    dateConversion = dateConversion.toDateString();
    // +
    // ", " +
    // dateConversion.toLocaleTimeString("en-US", {
    //   hour: "numeric",
    //   minute: "numeric",
    //   hour12: true,
    // });
    return dateConversion;
  };

  // let statuslist = [];

  let statuslist = [
    {
      status_id: "1",
      status_name: "Open",
    },
    {
      status_id: "2",
      status_name: "Close",
    },
    {
      status_id: "3",
      status_name: "Hold",
    },
  ];

  // if (props.statusFilter) {
  //   props.statusFilter.hits &&
  //     props.statusFilter.hits.hits &&
  //     props.statusFilter.hits.hits.length > 0 &&
  //     props.statusFilter.hits.hits.forEach((value) => {
  //       statuslist.push({
  //         status_id: value._id,
  //         status_name: value._source.status_name,
  //       });
  //     });
  // }

  const returnStatusName = (statusId) => {
    let filtered_status =
      statuslist.length > 0 &&
      statuslist.filter((val) => {
        return val.status_id === statusId;
      });

    return filtered_status.length > 0 ? filtered_status[0].status_name : ``;
  };

  let activity_type_uniqueList = [];

  props.activityTypeFilter &&
    props.activityTypeFilter.hits &&
    props.activityTypeFilter.hits.hits.forEach((item) => {
      activity_type_uniqueList.push({
        activity_type_id: item._id,
        activity_type_name: item._source.activity_type_name,
        campaign_id: item._source.campaign.campaign_id,
      });
    });

  const returnActivityTypeName = (activityId) => {
    let filtered_activity =
      activity_type_uniqueList.length > 0 &&
      activity_type_uniqueList.filter((val) => {
        return val.activity_type_id === activityId;
      });

    return filtered_activity.length > 0
      ? filtered_activity[0].activity_type_name
      : ``;
  };

  activity_type_uniqueList.sort((a, b) =>
    a?.activity_type_name.localeCompare(b.activity_type_name)
  );
  activity_type_uniqueList = [...new Set(activity_type_uniqueList)];

  const returnCampaignObj = () => {
    let campaign_obj = {};
    Object.assign(
      campaign_obj,
      location &&
        location.state &&
        location.state.campaign_id && {
          campaign_id: location.state.campaign_id,
        },
      location &&
        location.state &&
        location.state.campaign_name && {
          campaign_name: location.state.campaign_name,
        }
    );
    if (
      location &&
      location.state &&
      location.state.campaign_id &&
      location.state.campaign_name
    ) {
      return campaign_obj;
    }
  };

  let platform_list_for_post = [];
  if (props.influencerUser.hits?.hits[0]?._source) {
    props.influencerUser.hits?.hits[0]?._source.social_media_platforms.map(
      (item) => {
        platform_list_for_post.push({
          platform_id: item.platform_id,
          platform_name: item.platform_name,
        });
      }
    );
  }

  let platform_uniqueList = [];
  if (platform_list_for_post.length > 0) {
    platform_list_for_post.map((item) => {
      platform_uniqueList.push(item.platform_name);
    });
  }
  platform_uniqueList = [...new Set(platform_uniqueList)];

  let taglist_for_post = [];
  if (props.tagfilter) {
    props.tagfilter.hits &&
      props.tagfilter.hits.hits.length > 0 &&
      props.tagfilter.hits.hits.forEach((value) => {
        taglist_for_post.push({
          tag_id: value._id,
          tag_name: value._source.tag_name,
        });
      });
  }

  const returnActivityTagName = (tag_id) => {
    let filtered_tag =
      taglist_for_post.length > 0 &&
      taglist_for_post.filter((val) => {
        return val.tag_id === tag_id;
      });

    return filtered_tag.length > 0 ? `${filtered_tag[0].tag_name}, ` : ``;
  };

  let locationsList = [];

  if (props?.influencer_location?.influencer_location_data) {
    // Create a new array using map function
    locationsList = Object.values(
      props?.influencer_location?.influencer_location_data
    )
      .flat() // Flatten the arrays of countries
      .map((country) => `${country.country_name}, ${country.continent_name}`);
  }

  function createdDate(created) {
    let dateConversion = new Date(created);
    dateConversion =
      dateConversion.toDateString() +
      ", " +
      dateConversion.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    return dateConversion;
  }

  return (
    <React.Fragment>
      {/* *******************************************************Filters */}
      <Box ref={boxRef}>
        <Grid
          container
          sx={{
            position: "sticky",
            top: `${boxRef?.current?.offsetTop}px`,
            zIndex: 1,
            backgroundColor: theme.palette.background.default,
            // paddingX: "1.0%",
            paddingTop: 0,
            borderRadius: theme.borderRadius,
          }}
        >
          <Grid
            container
            xl={12}
            justifyContent="space-between"
            alignItems="center"
            mt={1}
          >
            <Typography
              pl={0.5}
              sx={{
                fontWeight: "bold",
                fontSize: "21px",
              }}
            >
              Activity List
            </Typography>
            <Grid item pr={2}>
              {location && location.state && location.state.campaign_name && (
                <h4 align="center" style={{ fontSize: "20px" }}>
                  Campaign name : {location.state.campaign_name}
                </h4>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              backgroundColor: theme.palette.background.default,
              paddingTop: 0,
              // borderRadius: theme.palette.buttonComponent.borderRadius.large,
              borderRadius: theme.borderRadius,
            }}
          >
            <Grid container>
              <TabContext value={value}>
                <Box
                  sx={{
                    borderBottom: "10px",
                    marginTop: 0,
                  }}
                >
                  <TabList
                    onChange={TabhandleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab
                      label="Filters"
                      value="1"
                      variant="h3"
                      sx={{ border: "none", marginTop: 0 }}
                    />

                    {/* <Tab
                  icon={<AutorenewSharpIcon style={{ fontSize: 22 }} />}
                  arial-label="refresh"
                  value="2"
                ></Tab> */}
                  </TabList>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    marginTop: "-29px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                    marginBottom: 1,
                  }}
                >
                  <Typography sx={{ display: "flex" }}>
                    {/* Last Sync Date : {""} {lastSynceDate} */}
                  </Typography>
                </Box>

                <Box sx={{ width: "100%" }}>
                  {/* <Divider
                variant="fullWidth"
                sx={{
                  borderRadius: "0.5px",
                  borderColor: theme.palette.background.comman,
                  borderStyle: "dotted",
                  marginBottom: "20px",
                }}
              /> */}

                  <hr style={{ marginTop: 0 }} />
                </Box>

                {/*Twitter filter */}
                <Box
                  sx={{
                    width: "100%",
                    padding: 0,
                    margin: 0,
                    backgroundColor: theme.palette.background.paper,
                    // borderRadius: theme.palette.buttonComponent.borderRadius.large,
                    border: "solid 0.5px #d3e2e6",
                    borderRadius: theme.borderRadius,
                  }}
                >
                  <TabPanel value="1">
                    <Grid
                      container
                      sx={{
                        margin: 0,
                        height: "auto",
                        padding: 0,
                        borderRadius: theme.borderRadius,
                      }}
                    >
                      <Grid
                        container
                        lg={12}
                        md={12}
                        sm={12}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid
                          item
                          xl={9}
                          lg={9}
                          md={12}
                          sm={12}
                          container
                          gap={2}
                          mt={1}
                        >
                          {location &&
                            location.state &&
                            (location.state?.from === "/InfluencersCampaigns" ||
                              location.state?.from ===
                                "/influencerDashboard") && (
                              <Grid
                                item
                                xl={1}
                                lg={1}
                                md={1}
                                sm={1}
                                mt={-1}
                                textAlign="left"
                              >
                                <IconButton
                                  title="Back to Campaign"
                                  onClick={() => {
                                    navigate(`/InfluencersCampaigns`, {
                                      state: {
                                        reverted: true,
                                        pageNumber: location
                                          ? location.state.pageNumber
                                          : null,
                                      },
                                    });
                                  }}
                                >
                                  <ArrowCircleLeftIcon
                                    style={{
                                      height: "40px",
                                      width: "40px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </IconButton>
                              </Grid>
                            )}

                          {selected && selected.includes("ActivityName") && (
                            <Grid item xl={1.8} lg={12} md={12} sm={12}>
                              <MuiTextField
                                value={activityNameValue}
                                variant="outlined"
                                placeholder={"Search Activity"}
                                sx={{ width: "100%" }}
                                size="small"
                                onChange={activityNameHandleChange}
                              />
                            </Grid>
                          )}

                          {location &&
                          location.state &&
                          (location.state?.from === "/InfluencersCampaigns" ||
                            location.state?.from === "/influencerDashboard")
                            ? ""
                            : selected &&
                              selected.includes("Campaign") && (
                                <Grid item xl={1.8} lg={12} md={12} sm={12}>
                                  <MuiTextField
                                    value={campaignNameValue}
                                    variant="outlined"
                                    placeholder={"Search Campaign"}
                                    sx={{ width: "100%" }}
                                    size="small"
                                    onChange={campaignNameHandleChange}
                                  />
                                </Grid>
                              )}
                          {selected && selected.includes("ActivityType") && (
                            <Grid item xl={1.8} lg={12} md={12} sm={12}>
                              <AutoCompleteComponent
                                // ***************************************************Customer name filter
                                value={activity_type_value}
                                list={activity_type_uniqueList}
                                disableClearable
                                textFieldProps={{
                                  placeholder: "Activity Type",
                                }}
                                getOptionLabel={(option) =>
                                  option.activity_type_name
                                    ? option.activity_type_name
                                    : ""
                                }
                                isOptionEqualToValue={(value, option) =>
                                  value.activity_type_id ===
                                  option.activity_type_id
                                }
                                handleChange={activityTypeHandleChange}
                                size="small"
                                width="100%"
                              />
                            </Grid>
                          )}

                          {selected && selected.includes("Platform") && (
                            <Grid item xl={1.8} lg={12} md={12} sm={12}>
                              <AutoCompleteComponent
                                // ***************************************************Customer name filter
                                value={platform_value}
                                list={platform_uniqueList}
                                disableClearable
                                textFieldProps={{
                                  placeholder: "Platform",
                                }}
                                handleChange={platform_HandleChange}
                                size="small"
                                width="100%"
                              />
                            </Grid>
                          )}

                          {selected && selected.includes("Location") && (
                            <Grid item xl={1.8} lg={12} md={12} sm={12}>
                              <AutoCompleteComponent
                                // ***************************************************Customer name filter
                                value={location_value}
                                list={locations_uniqueList}
                                disableClearable
                                textFieldProps={{
                                  placeholder: "Location",
                                }}
                                handleChange={location_HandleChange}
                                size="small"
                                width="100%"
                              />
                            </Grid>
                          )}

                          {selected && selected.includes("Tags") && (
                            <Grid item xl={2} lg={12} md={12} sm={12}>
                              <AutoCompleteComponent
                                // ***************************************************Customer name filter
                                multiple
                                value={tag_value}
                                list={taglist_for_post}
                                disableClearable
                                getOptionLabel={(option) =>
                                  option.tag_name ? option.tag_name : ""
                                }
                                isOptionEqualToValue={(value, option) =>
                                  value.tag_name === option.tag_name
                                }
                                textFieldProps={{
                                  placeholder: "Tags",
                                }}
                                handleChange={tag_HandleChange}
                                size="small"
                                width="100%"
                              />
                            </Grid>
                          )}

                          {selected && selected.includes("Date") && (
                            <Grid item xl={2.2} lg={12} md={12} sm={12}>
                              <DatePicker
                                value={date}
                                onChange={dateValueHandleChange}
                              />
                            </Grid>
                          )}
                        </Grid>

                        <Grid
                          item
                          xl={3}
                          lg={3}
                          md={12}
                          sm={12}
                          // className="bg-success"
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            container
                            spacing={2}
                            justifyContent="flex-end"
                            alignItems={"center"}
                          >
                            <Grid item xl={3.5} lg={6} md={3} sm={5} mt={1}>
                              <MuiButton
                                loading={filterLoader && isRequesting}
                                name={"Apply"}
                                width="100%"
                                onClick={applyFilter}
                              />
                            </Grid>
                            <Grid item xl={3.5} lg={6} md={3} sm={5} mt={1}>
                              <MuiButton
                                backgroundColor={theme.palette.secondary.main}
                                width="100%"
                                loading={clearLoader && isRequesting}
                                name={"Clear"}
                                onClick={ClearState}
                              />
                            </Grid>

                            <Grid item xl={2} lg={2} md={3} sm={5}>
                              <PostPlusButton
                                open={open}
                                openCloseModal={openCloseModal}
                                editMode={editMode}
                              />
                            </Grid>

                            <Grid item xl={1} lg={1} md={3} sm={5} mt={1}>
                              <IconButton
                                sx={{
                                  backgroundColor:
                                    theme.palette.background.paper,
                                }}
                                onClick={(e) => handleClick(e)}
                              >
                                {!openPopper ? (
                                  <MoreVertIcon
                                    sx={{ color: theme.palette.primary.main }}
                                  />
                                ) : (
                                  <ClearIcon
                                    sx={{ color: theme.palette.primary.main }}
                                  />
                                )}
                              </IconButton>
                              <Popper
                                sx={{ width: 200 }}
                                open={openPopper}
                                anchorEl={popperAnchor}
                              >
                                <Paper sx={{ p: 1.2 }} elevation={4}>
                                  {showDropDowns.map((item, index) => (
                                    <>
                                      <Box
                                        component="icon"
                                        style={{
                                          display: "flex",
                                          width: "100%",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              value={item}
                                              size="small"
                                              checked={
                                                selected &&
                                                selected.includes(item)
                                              }
                                              label={item}
                                              onChange={handleChangeDropDowns}
                                            />
                                          }
                                          label={item}
                                        />
                                      </Box>
                                    </>
                                  ))}
                                </Paper>
                              </Popper>
                            </Grid>

                            <AddAllActivity
                              open={open}
                              token={token}
                              onSubmit={() => {}}
                              onClose={() => {
                                setOpen(false);
                                setEdit(false);
                              }}
                              activityEditData={editRowsModel}
                              activityTypeList={activity_type_uniqueList}
                              campaignList={campaignList}
                              statusList={statuslist}
                              platformList={platform_list_for_post}
                              tagList={taglist_for_post}
                              edit={edit}
                              customticketfields={props.customticketfields}
                              campaign={
                                location &&
                                location.state &&
                                (location.state?.from ===
                                  "/InfluencersCampaigns" ||
                                  location.state?.from ===
                                    "/influencerDashboard")
                                  ? false
                                  : true
                              }
                              locationsList={locationsList}
                              location={location ? location : null}
                              campaign_obj={returnCampaignObj()}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TabPanel>
                </Box>
              </TabContext>

              {/* <Divider sx={{ borderColor: theme.palette.background.button }} /> */}
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            style={{ marginTop: "1%", marginBottom: "1%" }}
          >
            <hr style={{ marginTop: "4px", marginBottom: "4px" }} />
          </Grid>
          {/* ****************************************************** Divider */}
          <Grid
            container
            sx={{
              backgroundColor: theme.palette.background.paper,
              borderRadius: theme.borderRadius,
            }}
          >
            {/* ******************************************************PLay Store List */}

            <Box
              sx={{
                width: "100%",
                backgroundColor: theme.palette.background.default,
                border: "solid 0.5px #d3e2e6",
                boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.16)",
                borderRadius: theme.borderRadius,
              }}
              // className="bg-primary"
            >
              <Grid
                container
                sx={{
                  height: "auto",
                  paddingX: 2.5,
                  paddingBottom: 0,
                }}
              >
                <Grid container lg={12} md={12} sm={12} spacing={2}>
                  <Grid item lg={12} md={12} sm={12}>
                    <Grid container lg={12} display="flex-start">
                      <Grid item>
                        <h4>Activity</h4>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <hr style={{ marginTop: "4px", marginBottom: "4px" }} /> */}
              </Grid>

              <LoadingIndicator isActive={isRequesting}>
                {props.influencersActivity &&
                props.influencersActivity.hits &&
                !isRequesting &&
                props.influencersActivity.hits.hits.length > 0 ? (
                  props.influencersActivity.hits.hits.map((item, index) => (
                    <Box
                      sx={{
                        padding: 0,
                        margin: "1.2%",
                        marginTop: 0,
                        marginBottom: "0.5%",
                        borderRadius: theme.borderRadius,
                      }}
                      height={"auto"}
                      // onClick={() => {
                      //     navigateToMyPosts(item)
                      // }}
                    >
                      <Box
                        style={{
                          backgroundColor: "#fff",
                          height: "100%",
                          padding: 2,
                          borderRadius: theme.borderRadius,
                          border: "solid 0.5px #d3e2e6",
                          boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.16)",
                        }}

                        // component="nav"
                      >
                        <Grid
                          item
                          xl={12}
                          lg={12}
                          md={12}
                          sm={12}
                          container
                          textAlign={"center"}
                          justifyContent="center"
                          height="100%"
                        >
                          <Grid item xl={10} px={2}>
                            <Grid
                              item
                              container
                              xl={12}
                              justifyContent={"space-between"}
                            >
                              <Grid item textAlign={"left"} xs={7}>
                                <span
                                  style={{
                                    marginRight: "20px",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  }}
                                  // className="bg-warning"
                                >
                                  {item._source.activity_name}
                                </span>
                                <span>
                                  {`${returndate(
                                    item._source.activity_duration.from_date
                                      ? item._source.activity_duration.from_date
                                      : null
                                  )} - ${returndate(
                                    item._source.activity_duration.to_date
                                      ? item._source.activity_duration.to_date
                                      : null
                                  )}`}
                                </span>
                              </Grid>
                              <Grid item xs={3}>
                                {`Created On : ${createdDate(
                                  item._source.created_on
                                )}`}
                              </Grid>
                            </Grid>

                            <Grid
                              item
                              container
                              xl={12}
                              justifyContent={"space-between"}
                              alignItems="flex-start"
                            >
                              <Grid
                                item
                                xl={4}
                                // className="bg-warning"
                                textAlign={"left"}
                              >
                                <Typography textAlign={"left"}>
                                  {/* {item._source.campaign_description} */}
                                  Activity Type :{" "}
                                  {returnActivityTypeName(
                                    item._source.activity_type
                                  )}
                                </Typography>

                                <Typography textAlign={"left"}>
                                  {/* {item._source.campaign_description} */}
                                  Activity Status :{" "}
                                  {returnStatusName(
                                    item._source.activity_status
                                  )}
                                </Typography>

                                <Typography textAlign={"left"}>
                                  {/* {item._source.campaign_description} */}
                                  Activity Location :{" "}
                                  {item._source.activity_location}
                                </Typography>

                                <Typography textAlign={"left"}>
                                  {/* {item._source.campaign_description} */}
                                  Campaign Name :{" "}
                                  {item._source.campaign.campaign_name}
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xl={4}
                                // className="bg-warning"
                                textAlign={"left"}
                              >
                                <Typography textAlign={"left"}>
                                  {/* {item._source.campaign_description} */}
                                  Activity Platform:{" "}
                                  {returnLogo(
                                    item._source.activity_platform.platform_name
                                  )}
                                </Typography>

                                <Typography textAlign={"left"}>
                                  {/* {item._source.campaign_description} */}
                                  Activity Tags:{" "}
                                  {item._source.activity_tag
                                    ? item._source.activity_tag.map((item) => {
                                        // return returnActivityTagName(item);
                                      })
                                    : null}
                                </Typography>

                                <Typography textAlign={"left"}>
                                  Feed Engagements :
                                  {
                                    item?._source?.activity_post_details
                                      ?.engagements
                                  }
                                </Typography>

                                <Typography textAlign={"left"}>
                                  Assigned to :
                                  {item._source.influencer.influencer_name}
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xl={2}
                                // className="bg-info"
                              >
                                <Typography textAlign={"left"}>
                                  Feed Likes:
                                  {
                                    item?._source?.activity_post_details
                                      ?.like_count
                                  }
                                </Typography>

                                <Typography textAlign={"left"}>
                                  Feed Comments:
                                  {
                                    item?._source?.activity_post_details
                                      ?.feedbacks
                                  }
                                </Typography>

                                <Typography textAlign={"left"}>
                                  Impressions :
                                  {
                                    item?._source?.activity_post_details
                                      ?.impressions
                                  }
                                </Typography>
                              </Grid>

                              <Grid item lg={2} md={2} sm={2} mt={-1}>
                                <ListItem>
                                  <IconButton
                                    title="Edit"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.ignore = true;
                                      setEdit(true);
                                      setOpen(true);
                                      setEditRowsModel(item);
                                    }}
                                    sx={{ border: "0" }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faPenToSquare}
                                      style={{
                                        height: "20px",
                                        width: "20px",
                                        color: "#2a5e6c",
                                      }}
                                    ></FontAwesomeIcon>
                                  </IconButton>
                                </ListItem>
                                {item._source.activity_url && (
                                  <Grid item lg={0.5} md={0.5} sm={1} mt={-1}>
                                    <ListItem>
                                      <IconButton
                                        title="Open Link"
                                        onClick={(event) => {
                                          window.open(
                                            item._source.activity_url
                                          );
                                        }}
                                        sx={{ border: "0" }}
                                      >
                                        <OpenInNewIcon
                                          style={{
                                            width: "20px",
                                            width: "20px",
                                            color: `#2a5e6c`,
                                          }}
                                        />
                                      </IconButton>
                                    </ListItem>
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>

                            <Box my={1}>
                              <Typography textAlign={"left"}>
                                <Grid
                                  item
                                  container
                                  xl={12}
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  alignItems="flex-start"
                                  justifyContent="flex-start"
                                >
                                  <Grid
                                    item
                                    xl={1.5}
                                    lg={1.5}
                                    md={1.5}
                                    sm={1.5}
                                  >
                                    Activity Description :{" "}
                                  </Grid>
                                  <Grid
                                    item
                                    xl={10}
                                    lg={10}
                                    md={10}
                                    sm={10}
                                    textAlign="left"
                                    style={{
                                      // height: "auto",
                                      overflow: "auto",
                                      height: 50,
                                      overscrollBehaviorY: "contain",
                                      borderRadius: theme.borderRadius,
                                      border: "solid 0.5px #d3e2e6",
                                      boxShadow:
                                        "0px 1px 1px 0px rgba(0,0,0,0.16)",
                                      padding: 2,
                                    }}
                                  >
                                    <span className="text-wrap">
                                      {item._source.description}
                                    </span>
                                  </Grid>
                                </Grid>
                              </Typography>
                            </Box>

                            <Box my={1}>
                              <Typography textAlign={"left"}>
                                {/* Activity Description :{" "}
                              <span className="text-wrap">
                                {item._source.description}
                              </span> */}
                                <Grid
                                  item
                                  container
                                  xl={12}
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  alignItems="flex-start"
                                  justifyContent="flex-start"
                                >
                                  <Grid
                                    item
                                    xl={1.5}
                                    lg={1.5}
                                    md={1.5}
                                    sm={1.5}
                                  >
                                    Activity Content :{" "}
                                  </Grid>
                                  <Grid
                                    item
                                    xl={10}
                                    lg={10}
                                    md={10}
                                    sm={10}
                                    textAlign="left"
                                    style={{
                                      // height: "auto",
                                      overflow: "auto",
                                      height: 50,
                                      overscrollBehaviorY: "contain",
                                      borderRadius: theme.borderRadius,
                                      border: "solid 0.5px #d3e2e6",
                                      boxShadow:
                                        "0px 1px 1px 0px rgba(0,0,0,0.16)",
                                      padding: 2,
                                    }}
                                  >
                                    <span className="text-wrap">
                                      {item._source.activity_content}
                                    </span>
                                  </Grid>
                                </Grid>
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <NoDataFound />
                )}
              </LoadingIndicator>
            </Box>
          </Grid>
          {props.influencersActivity.hits
            ? props.influencersActivity.hits.hits.length !== 0 &&
              !isRequesting && (
                <PaginationUI
                  pagelength={props.pagination.total_page_no}
                  page={props.pagination.current_page_no}
                  handleChange={handleChangePagination}
                />
              )
            : null}
        </Grid>
      </Box>
      <MuiSnackbarAlert
        open={alertPopUp}
        onClose={() => setAlertPopUp(false)}
        message="No Filters Added !!"
      />
    </React.Fragment>
  );
}

export default connect(mapStateToProps)(InfluencersAllActivity);
